import * as React from 'react';
import { breakpoints } from '../common/constants';
import {
    DFP_AD_UNIT,
    Size,
    AD_UNIT_ROOTS,
    getPageSectionForAdUnit,
    AdvertSlotDfp,
    ADBRIDG_CLASS
} from '@zoopla/adverts';

type SlotConfig = {
    listingZeroIdxPos: number;
    adUnitCode?: DFP_AD_UNIT;
    sizes: Size[];
    position?: number;
    adbridgClass?: string;
};

const DEFAULT_DESKTOP_SIZES: Size[] = [[728, 90], [728, 110], 'fluid'];

const defaultDesktopSlot = {
    sizes: DEFAULT_DESKTOP_SIZES,
    adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_DESKTOP
};

export const DESKTOP_LSRP_AD_SLOT_POSITIONS: SlotConfig[] = [
    {
        ...defaultDesktopSlot,
        listingZeroIdxPos: 2,
        position: 0
    },
    {
        ...defaultDesktopSlot,
        listingZeroIdxPos: 7,
        position: 1
    },
    {
        ...defaultDesktopSlot,
        listingZeroIdxPos: 12,
        position: 2
    },
    {
        ...defaultDesktopSlot,
        listingZeroIdxPos: 17,
        position: 3
    },
    {
        ...defaultDesktopSlot,
        listingZeroIdxPos: 22,
        position: 4
    }
];

const DEFAULT_MOBILE_SIZES: Size[] = [[320, 50], 'fluid'];

const defaultMobileSlot = {
    sizes: DEFAULT_MOBILE_SIZES,
    adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_MOBILE
};

export const MOBILE_LSRP_AD_SLOT_POSITIONS: SlotConfig[] = [
    {
        ...defaultMobileSlot,
        listingZeroIdxPos: 0,
        position: 0
    },
    {
        ...defaultMobileSlot,
        listingZeroIdxPos: 7,
        position: 1
    },
    {
        ...defaultMobileSlot,
        listingZeroIdxPos: 12,
        position: 2
    },
    {
        ...defaultMobileSlot,
        listingZeroIdxPos: 17,
        position: 3
    },
    {
        ...defaultMobileSlot,
        listingZeroIdxPos: 22,
        position: 4
    }
];

export const IntegratedListingAdSlot: React.FC<{
    route: string;
    useMobileConfig: boolean;
    listingIndex: number;
}> = ({ route, useMobileConfig, listingIndex }) => {
    const adArray = useMobileConfig
        ? MOBILE_LSRP_AD_SLOT_POSITIONS
        : DESKTOP_LSRP_AD_SLOT_POSITIONS;

    const confIndex = adArray.findIndex(
        ({ listingZeroIdxPos }) => listingZeroIdxPos === listingIndex
    );

    if (confIndex === -1) return null;

    const ad = adArray[confIndex];

    return (
        <AdvertSlotDfp
            collapseEmpty
            showOnly={[useMobileConfig ? '<' : '>', breakpoints.lsrpSidebar]}
            sizes={ad.sizes}
            position={ad.position || 0}
            adUnitCode={
                ad.adUnitCode || [
                    AD_UNIT_ROOTS.INTERSTITIAL,
                    getPageSectionForAdUnit(route),
                    '/Slot-' + ((ad.position || 0) + 1)
                ]
            }
            adbridgClass={ad.adbridgClass}
        />
    );
};
